import React from "react";

const News = () => (
  <section id="news">
    <div className="row">
      <div className="twelve columns main-colr">
        <h2>お知らせ</h2>
          <p>2020.5.16 新型コロナウィルスの影響により2020年の一向一揆まつりは中止とさせていただきました。 詳しくは<a className="smoothscroll" href="#detail">こちら</a></p>
          <p>2019.8.4 たくさんのご来場ありがとうございました！！</p>
          <p>2019.8.3 いよいよ明日開催です！</p>
          <p>2019.7.10 ポスターを掲載しました。</p>
          <p>2019.6.1 スケジュールを更新しました。</p>
          <p>2019.4.1 サイトをオープンしました。</p>
      </div>
    </div>
  </section>
);

export default News;



// WEBPACK FOOTER //
// ./src/components/News.js